import { render, staticRenderFns } from "./ChallengeAction.vue?vue&type=template&id=cd18c530&scoped=true&"
import script from "./ChallengeAction.vue?vue&type=script&lang=js&"
export * from "./ChallengeAction.vue?vue&type=script&lang=js&"
import style0 from "./ChallengeAction.vue?vue&type=style&index=0&id=cd18c530&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd18c530",
  null
  
)

export default component.exports